module.exports = "<app-currency-converter></app-currency-converter>\n"